import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { RoleService } from 'src/app/core/services/role.service';
import { Observable, Subject, from, interval } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgentsService } from 'src/app/core/services/agents.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { takeUntil } from 'rxjs/operators';
import { Role } from '@models/enums';
import { AlerteModalComponent } from 'src/app/shared/alerte-modal/alerte-modal.component';
import { DelegationModalComponent } from 'src/app/features/administration/gestion-delegations/delegation-modal/delegation-modal.component';
import { MatDividerModule } from '@angular/material/divider';
@Component({
    selector: 'app-header',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatBadgeModule,
        MatMenuModule,
        MatDialogModule,
        MatTooltipModule,
        MatDividerModule,
        RouterModule
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  version: any;
  links: string[] = [
    'ACCUEIL',
    'SAISIES ET CONSULTATION',
    ' VALIDATION DES SAISIES',
    'EXPORT DES DONNÉES',
    'CONSULTATION FIN DE CONTRATS',
    'CONSULTATION ANNUAIRE DES POSTES',
    'ADMINISTRATION'
  ];
  activeLink: string = this.links[0];
  name: string | undefined;
  roleApplicatif: string | undefined;

  boutonNotifActif: boolean = false;
  userRoles: string[] = [];
  currentAgent$: Observable<any>;

  destroy$ = new Subject<void>();
  demanteToValidateObservable$: Observable<any>;
  isValidateur: boolean = false;

  userId: string | null = null;

  constructor(
    private readonly router: Router,
    private readonly keycloak: KeycloakService,
    public readonly dialog: MatDialog,
    private readonly roleService: RoleService,
    private readonly agentsService: AgentsService,
    private readonly notificationService: NotificationService
  ) {
    this.demanteToValidateObservable$ = this.notificationService.validationCounts$;
    this.version = environment.version;
    this.loadProfile()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user) {
          this.userId = user.id;
          this.name = user.username;
        }
      });
    this.roleService
      .getRole()
      .pipe(takeUntil(this.destroy$))
      .subscribe((roles) => {
        this.userRoles = roles as Role[];
        this.isValidateur = this.roleService.canAccess([Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR]);
      });
  }

  ngOnInit() {
    this.currentAgent$ = this.agentsService.getCurrentAgent();
    this.initValidationRefreshTask();
    this.currentAgent$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (result) => {},
      error: (error) => {
        this.dialog.open(AlerteModalComponent, {
          width: '640px',
          data: {
            title: 'Alerte',
            erreur: error.error
          }
        });
      }
    });

    this.roleService
      .getRole()
      .pipe(takeUntil(this.destroy$))
      .subscribe((roles) => {
        this.userRoles = roles;
        this.roleApplicatif = 'inconnu';
        if (this.userRoles != null && this.userRoles.length > 0) {
          this.userRoles.forEach((userRole) => {
            if (userRole != null && userRole.startsWith('pama-') && userRole != 'pama-user') {
              this.roleApplicatif = userRole;
            }
          });
        }
      });
  }

  initValidationRefreshTask() {
    this.notificationService.refreshValidationCounts(this.isValidateur);
    interval(30000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.notificationService.refreshValidationCounts(this.isValidateur);
      });
  }

  loadProfile(): Observable<any> {
    return from(this.keycloak.loadUserProfile());
  }

  addLink() {
    this.links.push(`Link ${this.links.length + 1}`);
  }
  logout() {
    sessionStorage.removeItem('isLoginAction');
    this.keycloak.logout(window.location.origin + '/');
  }

  redirection_accueil() {
    this.router.navigate(['/', 'pama']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  redirectNotification() {
    this.router.navigate(['/pama/validation-demandes'], { queryParams: { isRenouvellement: false } });
  }
  redirectNotificationRenouvellement() {
    this.router.navigate(['/pama/validation-demandes'], { queryParams: { isRenouvellement: true } });
  }

  manageUserDelegations() {
    this.dialog.open(DelegationModalComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        name: this.name,
        agentId: '',
        idUser: this.userId,
        viewMode: 'user'
      }
    });
  }
}
